import React, { Component } from 'react'
import fetch from 'isomorphic-fetch'

import Modal from '../../UI/Modal/Modal'
import ModalConfirm from '../../UI/Modal/ModalConfirm'
import Notification from '../../UI/Notifications/Notification'
import { ACERVO_URL } from '../../../../store/config'


class Migrations extends Component {

    state = {
        migrations: [],
        deleteSuccess: '',
        migrationSuccess: '',
        failedMigrations: [],
        successMigration: [],
        showModalConfirm: false,
        yearToDelete: '',
        e: React.createRef()
    }

    componentDidMount() {
        this._getAllMigrations()
    }

    _getAllMigrations = () => {
        const { access_token } = this.props.session.user.profile
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            },
            method: 'get'
        };

        const url = new URL(`${ACERVO_URL}/acervo-year-migrations?=year,asc`),
            params = { orderBy: ['year', 'asc'] }
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

        fetch(url, options)
            .then(result => {
                if (result.status >= 200 && result.status < 300) {
                    return result.json();
                } else {
                    return result.json().then(Promise.reject.bind(Promise));
                }
            })
            .then(response => {
                this.setState({
                    migrations: response
                })
            })
            .catch(console.log)
    }

    _deleteMigration = (e, year) => {
        e.persist()
        const currentClassName = e.target.className,
            loaddingClassName = ' is-loading'
        e.target.className = currentClassName + loaddingClassName

        const { access_token } = this.props.session.user.profile
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            },
            method: 'post'
        };

        const url = new URL(`${ACERVO_URL}/migrations/${year}/rollback`)

        fetch(url, options)
            .then(result => {
                if (result.status >= 200 && result.status < 300) {
                    return result.json();
                } else {
                    return result.json().then(Promise.reject.bind(Promise));
                }
            })
            .then(response => {
                e.target.className = currentClassName
                const { successMigration } = this.state
                successMigration.push(`La migración del año ${year}, se eliminó correctamente.`)
                this.setState({ successMigration }, () => this._getAllMigrations())
            })
            .catch(error => {
                console.error(error)
                e.target.className = currentClassName
                const failedMigrations = `Ocurrió un error.<br />Por favor inténtalo nuevamente más tarde.`
                this.setState({ failedMigrations })
            })
    }

    _makeMigration = (e, year) => {
        const currentClassName = e.target.className,
            loaddingClassName = ' is-loading'
        e.target.className = currentClassName + loaddingClassName
        e.persist()

        const { access_token } = this.props.session.user.profile
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            },
            method: 'post'
        };

        const url = new URL(`${ACERVO_URL}/migrations/${year}/migrate`)

        fetch(url, options)
            .then(result => {
                if (result.status >= 200 && result.status < 300) {
                    return result.json();
                } else {
                    return result.json().then(Promise.reject.bind(Promise));
                }
            })
            .then(response => {
                e.target.className = currentClassName
                const { successMigration } = this.state
                successMigration.push(`La migración del año ${year}, se realizó correctamente.`)
                this.setState({ successMigration }, () => this._getAllMigrations())
            })
            .catch(error => {
                console.error(error)
                e.target.className = currentClassName
                const { failedMigrations } = this.state
                failedMigrations.push(`La migración del año ${year}, no se pudo completar.<br />Por favor inténtalo nuevamente más tarde.`)
                this.setState({ failedMigrations })
            })
    }

    _closeConfirmModal = value => {
        this.setState({ showModalConfirm: value, yearToDelete: '' })
    }
    _successDeleteMigration = (value) => {
        const { e, yearToDelete } = this.state
        e.persist()
        this.setState({ showModalConfirm: value }, () => {
            this._deleteMigration(e, yearToDelete)
        })
    }

    render() {
        const { migrations, successMigration, failedMigrations, showModalConfirm } = this.state
        const { visible, closeModal } = this.props

        return (
            <div>
                <ModalConfirm title='Eliminar migración' confirm={this._successDeleteMigration} close={this._closeConfirmModal} isActive={showModalConfirm}>
                    <p>Se eliminará la migración, ¿Desea continuar?</p>
                </ModalConfirm>
                <Modal
                    title='Migrar Acervo'
                    visible={visible}
                >
                    <div className="is-home">
                        <div className="columns">
                            <div className="column">
                                {
                                    successMigration.length > 0 ?
                                        successMigration.map((element, key) => {
                                            return <Notification key={key} text={element} color='success' />
                                        }) : ''
                                }
                                {
                                    failedMigrations.length > 0 ?
                                        failedMigrations.map((element, key) => {
                                            return <Notification key={key} text={element} color='danger' />
                                        }) : ''
                                }
                            </div>
                        </div>
                        <div className="columns">
                            <div className="column">
                                <table className='table is-bordered is-fullwidth is-acervo'>
                                    <thead>
                                        <tr>
                                            <th className='has-text-centered'>#</th>
                                            <th className='has-text-centered'>año</th>
                                            <th className='has-text-centered'>migrado</th>
                                            <th>acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {migrations.map((migration, key) => {
                                            const isDisabledDelete = migration.status ? '' : 'is-static'
                                            const isDisabledMigrate = migration.status ? 'is-static' : ''
                                            return (
                                                <tr key={key}>
                                                    <td className='has-text-centered'>{key + 1}</td>
                                                    <td className='has-text-centered'>{migration.year}</td>
                                                    <td className='has-text-centered'>
                                                        <span className="icon">
                                                            <i className={migration.status ? 'has-text-success fa fa-check' : 'has-text-danger fa fa-times'}></i>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <div className='buttons'>
                                                            <a
                                                                disabled={migration.status ? 'disabled' : ''}
                                                                className={`button is-success is-small ${isDisabledMigrate}`}
                                                                onClick={e => this._makeMigration(e, migration.year)}
                                                            >Migrar</a>
                                                            <a
                                                                disabled={migration.status ? '' : 'disabled'}
                                                                className={`button is-danger is-small ${isDisabledDelete}`}
                                                                onClick={e => this.setState({ yearToDelete: migration.year, showModalConfirm: true, e })}
                                                            >Eliminar</a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className='is-pulled-right'>
                            <button className="button" onClick={closeModal}>Cerrar</button>
                        </div>
                    </div>
                </Modal>
            </div>

        )
    }
}

export default Migrations


// WEBPACK FOOTER //
// ./src/acervo/components/Sections/Main/Migrations.js